import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What age can my child start?',
  answer: 'We accept students as young as 3 years old in our Mini Troopers program. Our standard Kids Taekwondo classes start at age 6.'
}, {
  question: 'Does my child need experience?',
  answer: 'Not at all! The vast majority of our new students have no prior martial arts experience. Our beginner classes are designed to teach the fundamentals from day one.'
}, {
  question: 'Do parents need to buy gear before the trial?',
  answer: 'No gear is needed to start. Just wear comfortable athletic clothing for your trial classes.'
}];
export function KidsTaekwondoFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-2195" />;
}